export class CMG {
    id: number;
    code: string;
    name: string;
    description: string;
    departmentId: number;
    categoryId: number;
    bajaLogica: boolean;
    constructor(formData ? : any) {
        let data: any = !formData ? {} : formData;

        this.id = data.id || null;
        this.code = data.code || null;
        this.name = data.name || null;
        this.description = data.description || null;
        this.departmentId = data.categoryGroupId || null;
        this.categoryId = data.categoryId || null;
        this.bajaLogica = data.bajaLogica || null;
    }
}

export class ComboBox {
    id: number;
    code: string;
    name: string;

    constructor(formData ? : any) {
        let data: any = !formData ? {} : formData;

        this.id = data.id || null;
        this.code = data.code || null;
        this.name = data.name || null;
    }
}

export class Lider {
    id: number;
    liderId: string;
    cmgId: number;

    constructor(formData ? : any) {
        let data: any = !formData ? {} : formData;

        this.id = data.id || null;
        this.liderId = data.liderId || null;
        this.cmgId = data.cmgId || null;
    }
}